import { Annotation as VisxAnnotation, EditableAnnotation as VisxEditableAnnotation } from '@visx/annotation';
import BaseAnnotation from "./private/BaseAnnotation.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Annotation(_ref) {
  let {
    editable,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(BaseAnnotation, {
    AnnotationComponent: editable ? VisxEditableAnnotation : VisxAnnotation,
    ...props
  });
}